/**
 * Named manufacturers shown on the homepage Work section and Case Studies.
 * Do not add customers that are not approved. Do not add unverified metrics.
 */
export const endUsers = [
  {
    name: "Ford",
    slug: "ford",
    logo: "/ford2.png",
    descriptor:
      "Brownfield and greenfield engineering for AMR fleets across plant and logistics operations, from integration and commissioning through long-term support and customized software.",
  },
  {
    name: "Lucid",
    slug: "lucid",
    logo: "/vendor-partner-logos/lucid-logo.png",
    descriptor:
      "Greenfield automation assessments and planning, from a readiness review of plant operations to a defined path for automation investment.",
  },
];
